'use strict';

import minicart from '../../minicart';
import util from '../../util';

var initializeEvents = function() {
    $(document).on('change', '.miniproduct-info select.variation-select', function(e) {
        e.preventDefault();
        var $this = $(this);
        var selectedid = $this.val();

        var $minicartinfo = $this.closest('.miniproduct-info');
        var img = $('ul.product-variation-swatch-lists').find('#pdp-swatches .swatchanchor:has(img[alt="' + $(this).val() +'"])');
        var url = img.closest('a').attr('href');
        url = url.replace('Product-Variation','MiniProductContent-Show');
        if(url) {
            $minicartinfo.addClass('loading').load(url, function() { $minicartinfo.removeClass('loading'); });
        }
    });
    
    $(".pt_product-details").on("change","#quantity",function(e) {
        const $element = $('#quantity option:selected');
        const $salesPrice = $element.data('salesprice');
        const $listPrice = $element.data('listprice');
        const $btnElement = $("#cs-add-to-cart");

        if (!$salesPrice || !$listPrice) {
            return;
        }
        if($salesPrice != $listPrice) {
            if($(".show-ominibus-price").length) {
                $btnElement.find(".ominibus-price-sales .price-standard").text($listPrice);
                $btnElement.find(".ominibus-price-sales .o-sale-price").text($salesPrice);
            } else {
                $btnElement.find(".price-standard").text($listPrice);
                $btnElement.find(".price-sales").text($salesPrice);
            }
            
        } else {
            $btnElement.find(".price-sales").text($listPrice);
        }
    });

    $(document).on('click', '.regimen-button', function(e) {
        e.preventDefault();
        var pid = $(this).attr('data-pid');
        if(pid) {
        	var $addToBagErrorElement = $(this).closest('.product-form-actions').find('.alert');
            minicart.addProduct({pid: pid ,Quantity: 1},$addToBagErrorElement);
        }
    });

    $(document).on('click', '.miniproduct .mini-add-to-cart', function(e) {
        e.preventDefault();
        var pid = $(this).attr('data-pid');
        if(pid) {
        	var $addToBagErrorElement = $('.miniproduct-actions .global-add-to-bag .global-add-to-cart-error');
            minicart.addProduct({pid: pid},$addToBagErrorElement);
        }
    });
    
    $(document).on('click', '.miniproduct .mini-add-to-cart-set', function(e) {
        e.preventDefault();
        var pid = $(this).attr('data-pid');
        if(pid) {
            var $addToBagErrorElement = $('.miniproduct-actions .global-add-to-bag .global-add-to-cart-error');
            minicart.addSetProducts(e);
        }
    });

    $(document).on('click', '.persistant-tray-active .button-close', function(e) {
        e.preventDefault();
        var $container = $(this).closest('.persistant-tray-active');
        $container.addClass('closed');
    });

    $(window).scroll(function() {
        var $el = $('#persistant-threshold');
        if($el.length == 0) {return false;}

        var $persistanttray = $('.persistant-tray-active');
        if($(window).scrollTop() > $el.offset().top) {
            if($persistanttray.hasClass('hide')) {
                var $productinfo = $persistanttray.find('.miniproduct-info');
                var url = $productinfo.attr('data-miniproductcontenturl');
                if(url) {
                    $persistanttray.removeClass('hide closed');
                    $productinfo.addClass('loading').load(url, function() {
                    	$productinfo.removeClass('loading');
                    	var setPrice = $('.product-info #products-price span[itemprop="price"]').html();
                    	var setQty = Number($('.product-info .product-form-actions #quantity').val());
                    	$('.product-info .persistant-tray-active .product-price span[itemprop="price"]').html(setPrice);
                        $('.product-info .persistant-tray-active #quantity').text(setQty);
                        if($('#quantityset').length > 0) {
                            $('#quantityset').val($('#quantity').val());
                        }
                    });
                    
                    //add to bag -> enable and disable
                    util.delay(function(){			  
        	        	//add to bag -> enable and disable
        	        	var notAvailFlag = 0;
        	        	$('#product-set input[name="availability"]').each(function(){
        	                if($(this).val() == 'NOT_AVAILABLE'){
        	                	notAvailFlag = 1;
        	                }
        	            });
        	        	
        	        	if(notAvailFlag == 1){
        	        		$('.mini-add-to-cart-set').attr('disabled', true);
        	        	}else{
        	        		$('.mini-add-to-cart-set').attr('disabled', false);
        	        	}
        			  }, 1500);
                }
            }
        } else {
            if(!$persistanttray.hasClass('hide')) {
                $persistanttray.removeClass('closed').addClass('hide').find('.miniproduct-info').removeClass('loading').html('');
            }
        }
    });
}

var miniproduct = {
    init: function () {
        initializeEvents();
    }
};

export default miniproduct;
